module.exports = __webpack_public_path__ + "img/topPerformer.de802808.svg";